import { render, staticRenderFns } from "./usuariosTareas.vue?vue&type=template&id=c1e696d8&scoped=true&"
import script from "./usuariosTareas.vue?vue&type=script&lang=ts&"
export * from "./usuariosTareas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e696d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
